export default {
	namespaced: true,
	state: {
		list: [],
	},

	mutations:{
		list(state, payload) {
			state.list = payload
		},
	},
	getters:{
		list(state) {
			return state.list
		}
	},
	actions: {

	},

}